'use client'

import styled from 'styled-components'

export const AuthBrand = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
`

export const AuthPanel = styled.div`
    width: 100%;
    max-width: 25rem;

    .rt-Card {
        box-shadow: var(--shadow-5);
    }
`

/**
 * The shared Form lays fields out as "label | input" with the submit button on the right. In the auth card
 * the labels go above full-width inputs and the button spans the card. `&&` outweighs the Form's own styles.
 */
export const AuthFormLayout = styled.div`
    && .form-fields {
        grid-template-columns: 1fr;
        gap: 1rem;
        margin-bottom: 1.5rem;
    }

    && .form-item:not(.form-label-transition) {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        justify-items: stretch;
        row-gap: 0.375rem;
    }

    && .form-item label {
        padding-right: 0;
        font-size: var(--font-size-2);
        font-weight: 500;
        color: var(--gray-12);
    }

    && .form-item input {
        padding: 0.7rem 0.8rem;
        font-size: var(--font-size-3);
        color: var(--gray-12);
        border-radius: var(--radius-3);
        background-color: var(--color-surface);
    }

    && .form-item input:focus {
        border-color: var(--accent-8);
        box-shadow: 0 0 0 3px var(--accent-a4);
    }

    /* room for the eye icon */
    && .form-password-field input {
        padding-right: 2.75rem;
    }

    && .form-password-field svg {
        padding-inline: 0.85rem;
    }

    && .form-footer {
        display: block;
    }

    && .form-footer button {
        width: 100%;
        height: 2.75rem;
        font-size: var(--font-size-3);
    }
`
